import ko from "knockout";
import _ from "lodash";
import qualityManagementService from "services/qualityManagementService";
import ViewModel from "viewModels/ViewModel";
import errorCallbackFactory from "util/errorCallbackFactory";
import navHelper from "services/navHelper";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";
import SurveyErrorReason from "enums/SurveyErrorReason";

//this function is only here because Math.round() by itself sometimes does not produce correct results
//i.e if you put in Math.round(1.005 * 100) / 100, you would 1.00, instead of 1.01
const roundUpDecimals = function (num) {
    return +(Math.round(num + "e+2") + "e-2");
};

const SurveySummaryView = ViewModel.extend(function (conversationId) {
    const self = this;

    let SURVEY_SUMMARY_COLUMNS;

    const isVoiceSurveyToggleEnabled = featureToggleService.isEnabled(
        FeatureToggle.VOICE_SURVEY
    );

    SURVEY_SUMMARY_COLUMNS = [
        {
            label: "surveySummary.formNameTitle",
            id: "formName",
        },
        {
            label: "surveySummary.statusTitle",
            id: "status",
        },
        {
            label: "surveySummary.scoreTitle",
            id: "score",
        },
        {
            label: "surveySummary.npsScore",
            id: "npsScore",
        },
    ];

    if (isVoiceSurveyToggleEnabled) {
        SURVEY_SUMMARY_COLUMNS.splice(2, 0, {
            label: "surveySummary.surveyTypeTitle",
            id: "surveyType",
        });
    }

    self.surveySummaryGrid = ko.observableArray();

    const getStatusString = function (status) {
        let surveyStatus;
        if (status.toLowerCase() === "pending") {
            surveyStatus = "surveySummary.pending";
        } else if (status.toLowerCase() === "sent") {
            surveyStatus = "surveySummary.sent";
        } else if (status.toLowerCase() === "inprogress") {
            surveyStatus = "surveySummary.inProgress";
        } else if (status.toLowerCase() === "expired") {
            surveyStatus = "surveySummary.expired";
        } else if (status.toLowerCase() === "finished") {
            surveyStatus = "surveySummary.finished";
        } else if (status.toLowerCase() === "optout") {
            surveyStatus = "surveySummary.optOut";
        } else {
            surveyStatus = "surveySummary.error";
        }
        return surveyStatus;
    };

    const getErrorInfo = function (surveyErrorDetails) {
        const reason = surveyErrorDetails.surveyErrorReason.toLowerCase();
        let messageKey;
        let lastActionId;
        if (reason === SurveyErrorReason.BOUNCE) {
            messageKey = "surveySummaryView.bounced";
            lastActionId = surveyErrorDetails.flowDiagnosticInfo.lastActionId;
        } else if (reason === SurveyErrorReason.COMPLAINT) {
            messageKey = "surveySummaryView.complaint";
            lastActionId = surveyErrorDetails.flowDiagnosticInfo.lastActionId;
        } else if (reason === SurveyErrorReason.INTERNAL_PARTICIPANT) {
            messageKey = "surveySummaryView.internalParticipants";
        } else if (reason === SurveyErrorReason.DISABLED_SURVEY_FORM) {
            messageKey = "surveySummaryView.disabledSurveyForm";
        } else {
            messageKey = "surveySummaryView.unspecifiedError";
            lastActionId = surveyErrorDetails.flowDiagnosticInfo.lastActionId;
        }
        return {
            errorString: messageKey,
            lastActionId: lastActionId,
        };
    };

    const getSurveyType = function (type) {
        let surveyType;
        if (type && type.toLowerCase() === "voice") {
            surveyType = "surveySummary.voice";
        } else {
            surveyType = "surveySummary.web";
        }

        return surveyType;
    };

    self.listEntities = function (surveys) {
        const rows = _.map(surveys, function (survey) {
            let conversationId, formName, status, surveyType;
            let errorInfo = {};

            conversationId = survey.conversation.id;
            const href = navHelper.buildInteractionHash(
                "admin",
                conversationId,
                `qualitySummary/?surveyId=${survey.id}`
            );

            const totalScoreExists =
                survey.answers &&
                survey.answers.totalScore !== null &&
                survey.answers.totalScore !== undefined;

            const score = totalScoreExists
                ? roundUpDecimals(survey.answers.totalScore)
                : ko.i18n.renderString("evaluatorDashboard.score.unavailable");

            const scoreCell = {
                totalScore: score,
            };
            formName = survey.surveyForm.name;
            status = getStatusString(survey.status);
            surveyType = getSurveyType(survey.surveyType);

            if (status == "surveySummary.error" && survey.surveyErrorDetails) {
                errorInfo = getErrorInfo(survey.surveyErrorDetails);
            }

            const row = {
                conversationId: conversationId,
                surveyId: survey.id,
                formName: formName,
                status: status,
                score: scoreCell,
                npsScore: survey.answers ? survey.answers.npsScore : undefined,
                errorMessageKey: errorInfo.errorString,
                lastActionId: errorInfo.lastActionId,
                handleRowClick(bindingContext, event) {
                    event.preventDefault();
                    if (survey.answers && status === "surveySummary.finished") {
                        navHelper.navigateTo(href, undefined, false);
                    }
                },
            };

            if (isVoiceSurveyToggleEnabled) {
                row.surveyType = surveyType;
            }

            return row;
        });
        self.surveySummaryGrid().rows(rows);
    };

    self.surveySummaryGrid({
        columns: SURVEY_SUMMARY_COLUMNS,
        rows: ko.observableArray([]),
        selectedRows: ko.observableArray([]),
        loading: ko.observable(true),
    });

    qualityManagementService
        .getConversationSurveys(conversationId())
        .then(function (response) {
            self.listEntities(response);
            return null;
        })
        .catch(
            errorCallbackFactory.createCallback({
                namespace: "playback.surveySummaryRequest",
            })
        )
        .finally(function () {
            self.surveySummaryGrid().loading(false);
        });
});

export default SurveySummaryView;
